import { organizations } from '../organizations';
import type { MembershipSchema } from '../schema';

const highschoolOrganizationIds: number[] = [
  organizations.KddwEduHighschool_NHighschool.id,
  organizations.KddwEduHighschool_RHighschool.id,
  organizations.KddwEduHighschool_SHighschool.id,
];

export function extractHighSchoolMembership(memberships: MembershipSchema[]): MembershipSchema | undefined {
  return memberships.find((m) => highschoolOrganizationIds.includes(m.organization.id));
}

export function extractHighschoolEmail(membership: MembershipSchema): string | undefined {
  return (
    (membership.profile?.fields.find(({ fieldName }) => fieldName === 'schoolEmail')?.value as string) ?? undefined
  );
}

export function extractHighschoolStudentNumber(membership: MembershipSchema): string | undefined {
  return (
    (membership.profile?.fields.find(({ fieldName }) => fieldName === 'studentNumber')?.value as string) ?? undefined
  );
}
